import React from 'react'

function HeroNumbers() {
    return (
        <section className="home-hero-pp" id="about">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4 vcenter">
                        <div className="hero-content-pp pera-block">
                            <h1 className="mb20">Supporting Startup Tech Founders </h1>
                            <p className="h-light hero-number-p mt30" data-aos="fade-in" data-aos-delay="500"  >We will guide you through development, implementation, and maintenance in a cost-effective way. We have developed and delivered award-winning projects and supported successful grant awards and investor funded applications.</p>
                        </div>
                    </div>
                    <div className="col-lg-4 vcenter d-flex justify-content-center">
                        <div className="hero-numbers-image m-mt60">
                            <img src="images/janam.webp" alt="web" className="img-fluid" ata-aos="fade-in" data-aos-delay="400" />
                        </div>
                    </div>
                    <div className="col-lg-4 vcenter">
                        <div className="hero-right-cnt">
                            <div className="media">
                                <div className="ree-icon-set ree-stat-icn">
                                    <img src="images/icons/breif.webp" alt="web" className="w-100" />
                                </div>
                                <div className="ree-details-set user-info">
                                    <h4>500+<span >  Apps</span></h4>
                                    <p>We've delivered high-quality solutions with exceptional services and support add-ons.</p>
                                </div>
                            </div>

                            <div className="media mt40">
                                <div className="ree-icon-set ree-stat-icn">
                                    <img src="images/icons/ux.webp" alt="web" className="w-100" />
                                </div>
                                <div className="ree-details-set user-info">
                                    <h4>13+ <span >Years </span></h4>
                                    <p> Noorisys has been standing strong for the past 13 years, constantly evolving.</p>
                                </div>
                            </div>

                            <div className="media mt40">
                                <div className="ree-icon-set ree-stat-icn">
                                    <img src="images/icons/review.webp" alt="web" className="w-100" />
                                </div>
                                <div className="ree-details-set user-info">
                                    <h4>100+<span > Staff</span></h4>
                                    <p>Our team includes over 100 highly skilled developers and support professionals. </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default HeroNumbers